
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"36","viewBox":"0 0 100 62","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"100","height":"61.832","rx":"4","fill":"#ECC3FF"}}),_c('rect',{attrs:{"x":"8.131","y":"20.085","width":"83.74","height":"4.068","rx":"2.034","fill":"#B758E5"}}),_c('rect',{attrs:{"x":"8.131","y":"28.221","width":"83.74","height":"4.068","rx":"2.034","fill":"#B758E5"}}),_c('rect',{attrs:{"x":"8.131","y":"36.356","width":"83.74","height":"4.068","rx":"2.034","fill":"#B758E5"}}),_c('rect',{attrs:{"x":"8.131","y":"44.493","width":"83.74","height":"4.068","rx":"2.034","fill":"#B758E5"}}),_c('rect',{attrs:{"x":"8.131","y":"52.628","width":"83.74","height":"4.068","rx":"2.034","fill":"#B758E5"}}),_c('rect',{attrs:{"x":"19.084","y":"10.687","width":"62.595","height":"40.458","rx":"4","fill":"#7B01B5"}}),_c('rect',{attrs:{"x":"8.131","y":"5.695","width":"39.024","height":"4.068","rx":"2.034","fill":"#B758E5"}}),_c('path',{attrs:{"d":"M55.721 30.86a.5.5 0 010 .866l-7.646 4.418a.5.5 0 01-.75-.433v-8.836a.5.5 0 01.75-.433l7.646 4.418z","fill":"#fff"}})])
          )
        }
      }
    